import * as React from "react";
import * as ReactDOM from "react-dom";
export interface SiteStatusProps extends React.Props<SiteStatusControl> {
    cdnEndpoint: string;
    className?: string;
}

export class SiteStatusControl extends React.Component<SiteStatusProps, any> {
    constructor(props: SiteStatusProps) {
        super(props);
    }
       
    public render(): JSX.Element {
        return (
            <div className={`outline site-status ${this.props.className || ""}`}>
                <img className="error-icon" src={`//${this.props.cdnEndpoint}/bot-icons-v1/bot-framework-default-7.png`}/>
            {this.props.children}
            </div>); 
    }
}  



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/SiteStatusControl.tsx